<main id="guest-information" class="info">
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{_('my_page')}}</h1>
            <span class="icon back" @click="app.setPage('Menu')">
                chevron_left
            </span>
        </div>
    </header>
    <section>
        <div class="d_flex jc_spacebetween ai_center">
            <h2>
                <span class="symbol fill">account_circle</span
                >{{_('guest_title')}}
            </h2>
            <button
                class="secondary edit-btn"
                @click="openGuest(guest)"
                v-if="Object.keys(this.items).length"
            >
                {{_('edit')}}
            </button>
        </div>
        <p class="mt_20px" v-if="!Object.keys(this.items).length">
            {{_('no_input_items')}}
        </p>
        <table class="info" v-if="guest">
            <tr v-if="items.name">
                <th>{{_('name')}}</th>
                <td>{{guest.name}}</td>
            </tr>
            <tr v-if="items.name_kana">
                <th>{{_('name_kana')}}</th>
                <td>{{guest.name_kana}}</td>
            </tr>
            <tr v-if="items.country">
                <th>{{_('country')}}</th>
                <td>{{country()}}</td>
            </tr>
            <tr v-if="items.dob">
                <th>{{_('dob')}}</th>
                <td>{{birthDate()}}</td>
            </tr>
            <tr v-if="items.sex">
                <th>{{_('sex')}}</th>
                <td>{{ _(gender()) }}</td>
            </tr>
            <tr v-if="items.occupation">
                <th>{{_('occupation')}}</th>
                <td>{{occupation()}}</td>
            </tr>
            <tr v-if="items.email">
                <th>{{_('email')}}</th>
                <td>{{guest.email}}</td>
            </tr>
            <tr v-if="items.phone">
                <th>{{_('phone')}}</th>
                <td>{{guest.phone}}</td>
            </tr>
            <tr v-if="items.form_memo">
                <th>{{_('form_memo')}}</th>
                <td>{{guest.form_memo}}</td>
            </tr>
            <tr v-if="items.zip_code && guestLiveInJapan()">
                <th>{{_('zip_code')}}</th>
                <td>{{guest.zip_code}}</td>
            </tr>
            <tr v-if="items.prefecture && guestLiveInJapan()">
                <th>{{_('prefecture')}}</th>
                <td>{{prefecture()}}</td>
            </tr>
            <tr v-if="items.addr">
                <th>{{_('addr')}}</th>
                <td>{{guest.addr}}</td>
            </tr>
            <tr v-if="items.lastplace">
                <th>{{_('lastplace')}}</th>
                <td>{{guest.lastplace}}</td>
            </tr>
            <tr v-if="items.destination">
                <th>{{_('destination')}}</th>
                <td>{{guest.destination}}</td>
            </tr>
            <tr v-if="items.passport_id">
                <th>{{_('passport_id')}}</th>
                <td>{{guest.passport_id}}</td>
            </tr>
            <tr v-if="items.passport_path">
                <th>{{_('passport_path')}}</th>
                <td>
                    {{ guest.passport_path ? _('uploaded') : _('unuploaded') }}
                </td>
            </tr>
            <tr v-if="items.face_path">
                <th>{{_('face_path')}}</th>
                <td>{{ guest.face_path ? _('uploaded') : _('unuploaded') }}</td>
            </tr>
            <tr v-if="items.identification_path">
                <th>{{_('identification_path')}}</th>
                <td>
                    {{ guest.identification_path ? _('uploaded') :
                    _('unuploaded') }}
                </td>
            </tr>
        </table>
    </section>
    <tab-bar :page="app.query.page"></tab-bar>
</main>
